export default {
  SET_QUESTIONS_COURSE(state, value) {
    state.questions = value;
  },
  SET_LOADDING(state, value) {
    state.loadding = value;
  },
  SET_QUESTION_EDIT(state, value) {
    state.edit = value;
  },
  SET_QUESTION_SELECTED(state, value) {
    state.question_selected = value;
  },
};
